const firebaseConfig = {
    apiKey: "AIzaSyDcTQc4oama-s0_xT7PkuKMNMxX2d8Xgqk",
    authDomain: "na-healthcare-77.firebaseapp.com",
    projectId: "na-healthcare-77",
    storageBucket: "na-healthcare-77.appspot.com",
    messagingSenderId: "465428468967",
    appId: "1:465428468967:web:1dee5a0bd8a6c16be67e42"
  };
export default firebaseConfig;  